import { render, staticRenderFns } from "./SanctionDetail.vue?vue&type=template&id=5fbb1f16&scoped=true"
import script from "./SanctionDetail.vue?vue&type=script&lang=js"
export * from "./SanctionDetail.vue?vue&type=script&lang=js"
import style0 from "./SanctionDetail.vue?vue&type=style&index=0&id=5fbb1f16&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbb1f16",
  null
  
)

export default component.exports